/*
  FERROTECNIA — El recuento de la cabecera de categoría, al filtrar

  El recuento vive junto al título de la categoría y no en la fila de
  «Ordenar por», que es donde lo pone Dawn. Pero Dawn filtra sin recargar la
  página: repinta la rejilla y su propio recuento, y la cabecera —que es otra
  sección— se queda con la cifra de la llegada.

  Esto la mantiene al día. No repinta la sección entera ni pide nada al
  servidor: se apoya en que Dawn deja los dos números en el elemento que sí
  actualiza, `#ProductCount`, como `data-product-count` y `data-total-count`.
  Cuando cambian, se reescribe la cabecera.

  Un MutationObserver y no un parche dentro de `facets.js`: así una
  actualización de Dawn no se lleva esto por delante, y si el día de mañana
  desaparece el elemento, la cabecera se queda con el número del servidor —que
  es correcto al cargar— en lugar de romperse.
*/
(function () {
  const cabecera = document.querySelector('[data-recuento-categoria]');
  const fuente = document.getElementById('ProductCount');
  if (!cabecera || !fuente) return;

  const etiqueta = cabecera.dataset.recuentoEtiqueta || 'productos';
  const deUnTotal = cabecera.dataset.recuentoTotal || 'de un total de';

  // Mismo punto de millar que `miles.liquid`, para que la cifra no cambie de
  // aspecto al filtrar: 1.086 antes y 1.086 después.
  const miles = (n) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  const pintar = () => {
    const cuantos = parseInt(fuente.dataset.productCount, 10);
    const total = parseInt(fuente.dataset.totalCount, 10);
    if (!Number.isFinite(cuantos)) return;

    let texto = miles(cuantos);
    if (Number.isFinite(total) && cuantos < total) {
      texto += ' ' + deUnTotal + ' ' + miles(total);
    }
    cabecera.textContent = texto + ' ' + etiqueta;
  };

  new MutationObserver(pintar).observe(fuente, {
    attributes: true,
    attributeFilter: ['data-product-count', 'data-total-count'],
  });
})();
